<template>
  <div class="OJProblemManagement" style="background-color: #1C1C1C;">
    <div style="background-color: #1C1C1C;">
      <div style="text-align: center; color: #fff; font-size: 30px; font-weight: bold;">
        信奥 英雄榜
      </div>
      <div style="text-align: center;color: #9a9696;font-size: 14px;">
        坚持刷题，提高你的英雄排名
      </div>

      <div style="margin-top: 5px;">
        <div style=" text-align: center;">
          <el-radio-group v-model="tabPosition" size="mini" @change="search">
            <el-radio-button label="4">近一年</el-radio-button>
            <el-radio-button label="3">近一月</el-radio-button>
            <el-radio-button label="2">近一周</el-radio-button>
            <el-radio-button label="1">昨 日</el-radio-button>
          </el-radio-group>
        </div>
      </div>
      <div class="main">
        <div class="">
          <div class="containermain" style="font-size: 10px;">
            <div class="itemMian">排名</div>
            <div class="itemMian">头像</div>
            <div class="itemMian">姓名</div>
            <div class="itemMian">通过题目</div>
            <div class="itemMian">正确提交</div>
            <div class="itemMian">总提交</div>
            <div class="itemMian">通过率</div>
            <!-- 添加更多的项目 -->
          </div>
          <div v-infinite-scroll="load" style="overflow-y: auto; height: calc(100vh - 153px);" @scroll="handleScroll">
            <div class="containermain" v-for="(item, index) in tableData" :key="index" style="font-size: 10px;">
              <div class="itemMian">{{ isTch?item.school_rank:item.stu_school_rank }}</div>
              <div class="itemMian">
                <div style="border-radius: 50%; overflow: hidden; width: 20px;height: 20px; margin: 0 auto;">
                  <img :src="item.headImgUrl" style="width: 100%;height: 100%" />
                </div>
              </div>
              <div class="itemMian" style="overflow: hidden;white-space: nowrap;text-overflow: ellipsis; text-align: center;">
                {{ item.name }}
              </div>
              <div class="itemMian">{{ item.correct_problems }}</div>
              <div class="itemMian">{{ item.correct_submissions }}</div>
              <div class="itemMian">{{ item.total_submissions }}</div>
              <div class="itemMian">
                {{
                  (
                    (item.correct_submissions / item.total_submissions) *
                    100
                  ).toFixed(2) + "%"
                }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { h5GetOjTotalRank } from "@/api/match.js";
// import md5 from "js-md5";

import moment from "moment";
require("moment/locale/zh-cn");
export default {
  data() {
    return {
      returnObj: {},
      time1: "",
      time2: "",
      selfOjTotalRank: {},
      page_no: 1,
      page_size: 20,
      total: 0,
      tabPosition1: "1",
      tabPosition: "4",
      ri: "",
      yue: "",
      week: "",
      tableData: [],
      md5TXt: "",
      md5TXt1: "",
      schoolid: "",
      url: "",
      isTch: true
    };
  },
  mounted() {
    this.url = window.location.href;
    if (this.url.indexOf("?") > -1) {
      let paramStr = this.url.split("?")[1];
      let paramArr = paramStr.split("&");
      for (let i = 0; i < paramArr.length; i++) {
        let paramItem = paramArr[i].split("=");
        this.returnObj[paramItem[0]] = paramItem[1];
      }
      console.log(this.returnObj, 1245);
    }
    this.schoolid = this.returnObj.schoolid;
    this.md5TXt1 = this.returnObj.code;
    this.isTch = JSON.parse(this.returnObj.isTch || false);

    // console.log(this.schoolid, 12456);

    // console.log(this.md5TXt1, 123456);
    let m1 = moment();
    let m2 = moment("2024-10-19");
    let m3 = moment("2024-09-14");
    console.log(m2.diff(m1, "day"), 123456);
    this.time1 = m2.diff(m1, "day");
    this.time2 = m3.diff(m1, "day");

    this.yue = moment().format("MM");
    this.ri = moment().format("DD");
    const moment1 = require("moment");
    moment1.locale("zh-cn");
    this.week = moment().format("dddd");
    console.log(this.week, 123456);
    this.h5GetOjTotalRank();

    this.$nextTick(() => {
      document.title = "信奥排行榜";
    });

  },
  // watch: {
  //     'tableData.length'(val) {
  //         console.log(val, 12454)
  //         if (this.total > this.tableData.length) {
  //             this.load()
  //         }
  //     }
  // },
  methods: {
    handleScroll() {
      const distanceFromBottom =
        this.$el.clientHeight + this.$el.scrollTop - this.$el.scrollHeight;

      console.log(distanceFromBottom, 124545);
    },
    load() {
      if (this.total <= this.tableData.length) {
        console.log(1111);
      } else {
        this.page_no++;
        this.h5GetOjTotalRank();
      }
    },

    handleCurrent(val) {
      this.page_no = val;
      this.h5GetOjTotalRank();
    },

    h5GetOjTotalRank() {
      h5GetOjTotalRank({
        schoolId: this.schoolid,
        verifyCode: this.md5TXt1,
        is_self_school: this.tabPosition1,
        searchType: this.tabPosition,
        isTch: this.isTch,
        page_no: this.page_no,
        page_size: this.page_size,
      }).then((res) => {
        this.tableData.push(...res.ojTotalRankList);
        console.log(res, 123456);
        console.log(this.tableData, 123456);
        this.total = res.total;
      });
    },
    search() {
      this.tableData = [];
      this.page_no = 1;
      h5GetOjTotalRank({
        schoolId: this.schoolid,
        verifyCode: this.md5TXt1,
        is_self_school: this.tabPosition1,
        searchType: this.tabPosition,
        isTch: this.isTch,
        page_no: this.page_no,
        page_size: this.page_size,
      }).then((res) => {
        this.tableData.push(...res.ojTotalRankList);
        console.log(res, 123456);
        console.log(this.tableData, 123456);
        this.total = res.total;
        this.$nextTick(() => {
          console.log(this.total);
          console.log(this.tableData.length);
          if (this.total <= this.tableData.length) {
            console.log(1111);
          } else {
            this.page_no++;
            this.h5GetOjTotalRank();
          }
        });
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.containermain {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  border-bottom: 1px solid rgb(61, 60, 60);
  /* 水平居中对齐 */
}

.itemMian {
  color: #ffffff;
  text-align: center;
  flex: 1;
  margin: 5px;
  line-height: 30px;
}

.bgImg {
  width: 100%;
  padding-bottom: 15%;
  background-image: url("https://wugecdn.steam.fun/resources/static/oj_rank.jpeg");
  background-repeat: no-repeat;
  background-size: cover;
  // style="width: 100%;padding-bottom: 69%;  background-repeat: no-repeat;background-size: cover;"
}

.OJProblemManagement {
  padding: 10px;
  font-size: 14px;
  background-color: #1c1c1c !important;
  height: calc(100vh - 20px);
  overflow: hidden;
}

.fl {
  float: left;
}

.fr {
  float: right;
}

.clearfix:after {
  content: "";
  display: block;
  visibility: hidden;
  clear: both;
}

.top {
  padding: 20px;
  padding-bottom: 0px;
  font-size: 18px;
  font-weight: 300;
}

.main {
  margin-top: 10px;
  // padding: 20px;
  box-sizing: border-box;
}

/deep/ .el-radio-group {
  margin-top: 7px;
}

/deep/ .el-divider--horizontal {
  margin-top: 0px;
}

/deep/ .el-radio-button__orig-radio:checked + .el-radio-button__inner {
  background-color: #ffb142;
  border-color: #ffb142;
}
</style>
